import { render, staticRenderFns } from "./SelectNationality.vue?vue&type=template&id=54acac8e"
import script from "./SelectNationality.vue?vue&type=script&lang=js"
export * from "./SelectNationality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports